import React from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

function ModalViewImage(params) {
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <React.Fragment>
            <IconButton color="secondary" size="small" onClick={handleClickOpen} style={{marginRight:"10px"}}>
                <InsertPhotoIcon />
            </IconButton>
            {/* <Button onClick={handleClickOpen}>Abrir Imagen</Button> */}
            <Dialog
                fullScreen
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableRestoreFocus
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {params.area}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <img
                        src={params.url}
                        alt="Articulo"
                        style={{
                            width: '100%',       // Ajusta el ancho al 100% del contenedor
                            height: 'auto',      // Mantiene la proporción de aspecto
                            objectFit: 'contain' // Asegura que la imagen se escale sin recortar
                        }}
                    />
                </DialogContent>
            </Dialog>

        </React.Fragment>
    )
}

export default ModalViewImage;